import { Box, Flex } from './atoms/Layout'
import styled from '@emotion/styled'
import theme from '@nextretreat/ui-components/dist/Theme'
import { Text } from './atoms/Typography'
import { rem } from 'polished'

export const CARD_WIDTH = rem(500)
interface IInputDescriptionWrap {
  text: string
  children: React.ReactNode
}

const WidthWrapper = styled(Box)`
  max-width: ${CARD_WIDTH};
  width: 100%;
`

const StyledFlex = styled(Flex)`
  & > * {
    flex: 1;
    flex-basis: 0;

    &:first-child {
      border-right: 1px solid ${theme.COLORS.BG_DIVIDER};
    }
  }
`

export const InputDescriptionWrap = ({
  children,
  text,
}: IInputDescriptionWrap) => (
  <StyledFlex maxWidth={`calc(${CARD_WIDTH} * 2)`}>
    <WidthWrapper pr={rem(24)}>{children}</WidthWrapper>

    <Text
      as="p"
      pl={rem(24)}
      textAlign="left"
      color={theme.COLORS.TXT_DEFAULT}
      fontSize={theme.fontSizes.s}
      lineHeight={theme.lineHeights.s}
    >
      {text}
    </Text>
  </StyledFlex>
)
